import { axios } from '@/utils/request'

/**
 * 查询结账管理（体检）
 *
 * @author 张禹尧
 * @date 2023-02-27 09:49:05
 */
export function baCheckoutExamPage (parameter) {
  return axios({
    url: '/baCheckoutExam/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 结账管理（体检）列表
 *
 * @author 张禹尧
 * @date 2023-02-27 09:49:05
 */
export function baCheckoutExamList (parameter) {
  return axios({
    url: '/baCheckoutExam/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加结账管理（体检）
 *
 * @author 张禹尧
 * @date 2023-02-27 09:49:05
 */
export function baCheckoutExamAdd (parameter) {
  return axios({
    url: '/baCheckoutExam/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑结账管理（体检）
 *
 * @author 张禹尧
 * @date 2023-02-27 09:49:05
 */
export function baCheckoutExamEdit (parameter) {
  return axios({
    url: '/baCheckoutExam/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除结账管理（体检）
 *
 * @author 张禹尧
 * @date 2023-02-27 09:49:05
 */
export function baCheckoutExamDelete (parameter) {
  return axios({
    url: '/baCheckoutExam/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出结账管理（体检）
 *
 * @author 张禹尧
 * @date 2023-02-27 09:49:05
 */
export function baCheckoutExamExport (parameter) {
  return axios({
    url: '/baCheckoutExam/exportDetail',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}


/**
 * 查看结账详情
 *
 * @author 张禹尧
 * @date 2023-02-27 09:49:05
 */
export function baCheckoutExamDetial (parameter) {
  return axios({
    url: '/baCheckoutExam/getDetailList',
    method: 'get',
    params: parameter,
  })
}
